import React from 'react';
import i18n from 'i18n-react';

import { ContentHeader, Toolbox, BackButton } from 'C4';

const ToolboxView = () => (
  <div className="contentContainer">
    <ContentHeader
      header={i18n.translate('nav.sell')}
      subtitle={i18n.translate('pageDescriptions.sell')}
      social
      line
    />
    <Toolbox />
  </div>
);

export default ToolboxView;
